<template>
  <div>
    <input class="e-input" type="text" v-model='searchNum' @keydown.enter='keydown'  style="width: 200px;margin:0px 5px 5px 0px">
    <button :title='$t("MCS.superSearch")' class="my-class e-btn e-tbar-btn icon hero-icon hero-icon-search" @click='getGridData' data-ripple="true" tabindex="-1">
    </button>
    <ejs-grid ref='grid' :dataSource="data" height='100%' :allowReordering='true' :allowResizing='true'>
      <e-columns>
        <e-column field='groupId' :headerText='$t("MCS.groupNum")' clipMode='EllipsisWithTooltip' width='150' textAlign='Center'></e-column>
        <e-column field='groupType' clipMode='EllipsisWithTooltip' :valueAccessor='grouptypeFormatter' :headerText='$t("MCS.groupType")' width='150' textAlign='Center'></e-column>
        <e-column field='groupAlias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupAlias")' width='150' textAlign='Center'></e-column>
        <e-column field='groupOwner' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupOwner")' width='150' textAlign='Center'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
  </div>
</template>

<script>
import commonJS from '../../common';

export default {
  name: 'GroupTableLayer',
  mixins: [commonJS],
  data() {
    return {
      data: {},
      info: '',
      userNumSearch: '',
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      searchNum: ''
    };
  },
  methods: {
    keydown(event){
      event.stopPropagation();//禁用回车事件
    },
    getGridData(ne = null) {
      const $this = this;
      let vo;
      if (ne !== null && ne.msgid !== undefined) {
        $this.info = ne;
      }
      vo = {
        enterpriseDomain: $this.enterpriseDomain,
        productType: $this.productType,
        groupId: $this.searchNum,
        vpnId: 0,
        vpnClass: 0,
        flag: 2
      };
      const params = {
        info: $this.info,
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: $this.page.pageSize
        }
      };
      console.log('params', params);
      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data;
        const resData = res.resultVal.result;
        $this.data = resData;
        $this.page.totalCount = res.resultVal.totalCnt;
      });
    },

    getClickData() {
      return this.$refs.grid.getSelectedRecords()[0];
    }
  },
};
</script>

<style scoped>

  .my-class.e-btn:active,.my-class.e-btn:focus{
    box-shadow: none !important;
  }

  .my-class{
    width: 30px;
    height: 30px;
    padding: 0px;
    color: #007bff;
    background-color: #FFFFFF;
    border: 0px;
  }
</style>
